import React from "react";

export interface WarningIconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  color?: string;
}

export const WarningIcon: React.FC<WarningIconProps> = ({
  width = 17,
  height = 16,
  color = "#6941FF",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.34961 10.5005C8.80794 10.5005 9.18294 10.8755 9.18294 11.3338C9.18272 11.792 8.80781 12.1672 8.34961 12.1672C7.89141 12.1672 7.5165 11.792 7.51628 11.3338C7.51628 10.8755 7.88294 10.5005 8.34961 10.5005Z"
      fill={color}
    />
    <path
      d="M8.34147 4.3335C8.80171 4.3335 9.1748 4.70659 9.1748 5.16683V8.50016C9.17472 8.96033 8.80165 9.3335 8.34147 9.3335C7.88138 9.33339 7.50823 8.96026 7.50814 8.50016V5.16683C7.50814 4.70666 7.88132 4.3336 8.34147 4.3335Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.33333 0C8.73004 5.20284e-07 9.14103 0.0985652 9.50439 0.310872L9.50521 0.310059C9.5067 0.310911 9.50779 0.312459 9.50928 0.313314C9.51152 0.314632 9.51436 0.315242 9.5166 0.316569L9.51579 0.317383C9.8373 0.503557 10.0937 0.756169 10.2856 1.04899L10.3654 1.17839L16.3566 11.6699C16.3722 11.6972 16.3859 11.7255 16.3981 11.7537C16.5736 12.0892 16.6585 12.4571 16.6585 12.8247C16.6585 13.2304 16.5567 13.6375 16.342 13.9998C16.1373 14.3452 15.845 14.6375 15.4997 14.8421C15.1375 15.0567 14.7309 15.1586 14.3254 15.1587H2.33317V15.1571C1.92197 15.1652 1.52219 15.0578 1.17025 14.8568C1.16653 14.8546 1.16254 14.8524 1.15885 14.8503C0.813526 14.6456 0.521205 14.3533 0.316569 14.008C0.31264 14.0013 0.308919 13.9944 0.305176 13.9876C0.117546 13.6498 6.17427e-05 13.2454 0 12.8337C0 12.4387 0.100714 12.0228 0.316569 11.6585L6.30127 1.17839L6.38265 1.04574C6.58211 0.74466 6.84664 0.496406 7.15006 0.316569C7.15378 0.314366 7.15771 0.312204 7.16146 0.310059C7.52374 0.103042 7.92518 0 8.33333 0ZM8.33333 1.66667C8.21036 1.66667 8.0969 1.69615 7.99398 1.75374C7.8935 1.81462 7.80746 1.90087 7.74821 2.00439L7.74902 2.00521L1.757 12.4967C1.75483 12.5005 1.75272 12.5044 1.75049 12.5081C1.69968 12.5939 1.66667 12.7119 1.66667 12.8337C1.66673 12.9346 1.69742 13.0575 1.75537 13.1665C1.81608 13.2658 1.90324 13.352 2.00277 13.4123C2.10781 13.471 2.21213 13.495 2.30631 13.492H14.3254C14.4528 13.492 14.5625 13.4601 14.6501 13.4082C14.7547 13.3462 14.846 13.2549 14.908 13.1502C14.96 13.0625 14.9919 12.9523 14.9919 12.8247C14.9918 12.6973 14.9599 12.5876 14.908 12.5C14.8939 12.4761 14.8813 12.4515 14.8698 12.4268L8.91764 2.00521C8.8517 1.89008 8.77124 1.8101 8.67838 1.757C8.67465 1.75486 8.67069 1.75268 8.66699 1.75049C8.58314 1.7008 8.46579 1.66667 8.33333 1.66667Z"
      fill={color}
    />
  </svg>
);
